import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";
import { TypographyInlineCountdown } from '../style/typography';
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
dayjs.extend(utc);
dayjs.extend(timezone);

export default function InlineReportCountdown({ occued_at, addedMinutes }) {
    const [timeLeft, setTimeLeft] = useState("");
    const [targetReportTime, setTargetReportTime] = useState("");

    useEffect(() => {
        if (!occued_at) return;

        const occuredTime = dayjs(occued_at);
        const adjustedTargetTime = occuredTime.add(addedMinutes, "minute");

        const updateTimer = () => {
            const now = dayjs();
            const diff = adjustedTargetTime.diff(now, "second");
            let hours, minutes;
            if (diff < 0) {
                const passedDiff = Math.abs(diff);
                hours = String(Math.floor(passedDiff / 3600)).padStart(2, "0");
                minutes = String(Math.floor((passedDiff % 3600) / 60)).padStart(2, "0");
                setTimeLeft(`報告時間が ${hours}時間${minutes}分 過ぎました`);
            } else {
                hours = String(Math.floor(diff / 3600)).padStart(2, "0");
                minutes = String(Math.floor((diff % 3600) / 60)).padStart(2, "0");
                setTimeLeft(`報告時間まであと${hours}時間${minutes}分`);
            }
        };

        setTargetReportTime(adjustedTargetTime.format("YYYY年M月D日 HH:mm"));
        updateTimer();
        const timer = setInterval(updateTimer, 60 * 1000);
        return () => clearInterval(timer);
    }, [occued_at, addedMinutes]);

    return (
        <Box component="span">
            <TypographyInlineCountdown
                component="span"
                sx={{ fontSize: '0.2rem' }}
            >
                {timeLeft}
            </TypographyInlineCountdown>
        </Box>
    );
}